var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrowAggrep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 228 343.1",
    style: {
      enableBackground: "new 0 0 228 343.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D41B4B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.7,341.5c0.3-0.3,0.6-0.6,0.9-0.9l99.3-97.2c3.2-2.9,3.4-7.9,0.4-11.1c-1.5-1.6-3.5-2.5-5.6-2.5h-52.2 V104c0-4.7-1-9.9-5.2-9.9H70.5c-5.3,0.6-9.6,4.7-10.4,9.9v125.9h-47c-3.1,0.1-5.9,1.9-7.3,4.7v3.1c0.1,2.2,1,4.2,2.6,5.7 l98.7,97.2C109.5,343.5,113.8,343.9,116.7,341.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162,70.5c0-4.3-3.5-7.8-7.8-7.8H70.5c-4.3,0-7.8,3.5-7.8,7.8s3.5,7.8,7.8,7.8h83.6 C158.5,78.4,162,74.9,162,70.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162,39.2c0-4.3-3.5-7.8-7.8-7.8H70.5c-4.3,0-7.8,3.5-7.8,7.8s3.5,7.8,7.8,7.8h83.6 C158.5,47,162,43.5,162,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162,7.8c0-4.3-3.5-7.8-7.8-7.8L70.5,0c-4.3,0-7.8,3.5-7.8,7.8s3.5,7.8,7.8,7.8h83.6 C158.5,15.7,162,12.2,162,7.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowAggrep);
export default __webpack_public_path__ + "static/media/down_arrow_aggrep.08a7e8d757cf259f022ac1a6947e6b1b.svg";
export { ForwardRef as ReactComponent };